<template>
  <div id="Company" class="view">
    <div class="company_title">
      <h3 v-text="company.name"></h3>
      <button class="btn btn-tiny btn-yellow"
        :disabled="company.id === user.company.id"
        @click="$store.dispatch('user/setDefault', company.ref)">Velg som standard</button>
    </div>
    <h4>Firmakode</h4>
    <div class="code">
      <h5>{{company.code}}</h5>
      <!--button-- class="btn btn-yellow d4-generate" @click="newCode()"><span>NY KODE</span></!--button-->
    </div>
    <br>
    <div class="spacer" />
    <div class="switch-label">
      <span>Steng tilgang for nye brukere</span>
      <label class="switch">
        <input type="checkbox" :checked="company.locked" name="locked" @change="company.ref.update({locked: !company.locked})">
        <span class="slider"></span>
      </label>
    </div>
    <p>ⓘ Koden vil ikke fungere for nye brukere som prøver å koble seg til firma, før firmakode låses opp igjen.</p>
    <div class="spacer" />
    <div class="invites">
      <h4>Invitere til firma:</h4>
      <form class="invite" @submit.prevent="newInvite">
        <input type="email" v-model="email" placeholder="Epost addresse" required>
        <input type="submit" value="send" :class="{disabled: !isEmail}" class="btn btn-yellow">
      </form>
      <p v-if="!invites.length">Invitasjoner vil bli vist her</p>
      <div v-for="invite in invites" :key="invite.id" class="row" @click="removeInvite(invite)">
        <span style="padding: 1rem;">ⓧ</span>
        <span style="flex: 1">
          <p>{{invite.email}}</p>
          <small>{{invite.date.toDate().toDateString()}}</small>
        </span>
        <span class="tag">{{invite.status}}</span>
      </div>
    </div>
    <router-link :to="{name: 'users'}" class="btn btn-small btn-link">Administrere ansatte</router-link>
    <br>
    <Loader :visible="loading" />
  </div>
</template>

<script>
import Loader from '@/components/Loader.vue'

function makeCode (len) {
  let code = ''
  const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789'

  for (let i = 0; i < len; i += 1) {
    code += possible.charAt(Math.floor(Math.random() * possible.length))
  }

  return code
}

export default {
  name: 'Company',
  components: { Loader },
  data () {
    return {
      loading: false,
      invites: [],
      unsub: null,
      email: '',
    }
  },
  computed: {
    user () {
      return this.$store.state.user.data
    },
    company () {
      return this.$store.state.user.company
    },
    isEmail () {
      if (!this.email || this.email.length < 7) return false
      const reg = /^.*@.*(\.\w{2,3})+$/
      return !!reg.test(this.email)
    },
  },
  methods: {
    newCode () {
      if (this.company) {
        this.loading = true
        this.company.ref.update({
          code: makeCode(7),
        }).then(() => {
          this.loading = false
        }).catch(() => {
          this.$toasted.show('Kunne ikke endre kode')
          this.loading = false
        })
      }
    },
    newInvite () {
      if (this.loading || !this.isEmail) return
      this.loading = true
      if (this.inviteExists(this.email)) {
        this.$toasted.show('Du har allerede inviteret denne epost addressen')
        return
      }
      this.company.ref.collection('invites').add({
        email: this.email,
        status: 'new',
        date: new Date(),
      }).then(() => {
        this.email = ''
        this.loading = false
        this.$toasted.show('Sender invitasjon')
      }).catch(() => {
        this.$toasted.show('Mislyktes')
      })
    },
    inviteExists () {
      if (!this.email || !this.invites.length) return false
      return this.invites.find(({ email }) => email === this.email)
    },
    removeInvite (invite) {
      if (!invite || !invite.ref) return
      this.$toasted.show('Fjern denne invitasjonen?', {
        theme: 'toasted-primary',
        duration: 10000,
        action: {
          text: 'Ja',
          onClick: (e, toastObject) => {
            toastObject.goAway(0)
            this.loading = true
            invite.ref.delete().then(() => {
              this.loading = false
            })
          },
        },
      })
    },
  },
  mounted () {
    this.$store.dispatch('user/checkToken')
    this.unsub = this.company.ref.collection('invites').onSnapshot((snaps) => {
      const arr = []
      if (snaps.size) {
        snaps.forEach((snap) => {
          const data = snap.data()
          data.id = snap.id
          data.ref = snap.ref
          arr.push(data)
        })
      }
      this.invites = arr
    })
  },
  beforeDestroy () {
    if (this.unsub) this.unsub()
  },
}
</script>

<style lang="scss">
#Company {
  align-items: flex-start;
  justify-content: flex-start;

  .code {
    display: flex;
    align-items: center;
    background: #fff;
    border-radius: 8px;
    padding: 2px 2px 2px 16px;
    width: 100%;
    margin: 4px 0;
    box-shadow: 0 0px 4px var(--dark-faded);

    h5 {
      flex: 1;
    }

    button {
      width: 48px;
      height: 48px;
      padding: 2px;

      span {
        display: block;
        font-size: 10rem;
        font-family: var(--altFont);
      }
    }
  }

  .invites {
    width: 100%;

    div.row {
      display: flex;
      cursor: pointer;
      justify-content: space-between;
      align-items: center;
      margin-top: 2rem;

      p {
        margin: 0;
      }

      .tag {
        padding: 2px 10px;
        border-radius: 12px;
        color: var(--primary);
        border: 1px solid var(--primary);
      }
    }
  }

  form.invite {
    display: flex;
    align-items: center;
    background: #fff;
    border-radius: 8px;
    padding: 2px 2px 2px 16px;
    width: 100%;
    margin: 2rem 0 4rem;
    box-shadow: 0 2px 8px var(--dark-faded);

    input[type="email"] {
      flex: 1;
      border: none;
      outline: none;
      font-size: 18rem;
    }

    input.btn {
      width: 60px;
      height: 48px;
      padding: 2px 4px;
      font-family: var(--altFont);
      box-shadow: 0 0 10px 1px var(--dark-faded);
      -webkit-appearance: initial;
    }
  }

  .btn-link {
    text-decoration: underline;
    margin: 2em auto 0;
  }

  .spacer {
    display: block;
    margin: 14px 0;
    width: 100%;
    height: 1px;
    border-bottom: 2px dashed var(--dark-faded);
  }

  .switch-label {
    margin: 0;
    width: 100%;
    display: flex;
    align-items: center;

    &>span {
      flex: 1;
      margin: 0 16px 0 0;
      font-size: 16rem;
      font-weight: 600;
    }
    .switch {
      width: 60px;
      height: 36px;
    }
  }
}
</style>

